export default "/_next/static/images/6da6800c6e7e8d719dd28ac10dd0473a.png";